import { render, staticRenderFns } from "./SalarySchemeList.vue?vue&type=template&id=46d55515&"
import script from "./SalarySchemeList.vue?vue&type=script&lang=js&"
export * from "./SalarySchemeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports